module.exports = __webpack_public_path__ + "img/img4.35bdc81a.jpg";